module.exports = "/_next/static/images/salary-on-demand-8d45c609919f18731f48b0d77a916753.svg";